// Mock data for Astoria Solutions

export const siteInfo = {
  name: "ASTORIA SOLUTIONS",
  tagline: "EVOLVE INTO YOUR HIGHEST STANDARD",
  email: "contact@astoriasolutions.com",
  phone: "+91 9876543210",
  address: {
    line1: "ASTORIA SOLUTIONS",
    line2: "UNIT NO 0811, ECOSPACE BUSINESS PARK",
    line3: "T5A, 8TH FLOOR, PLOT IIF/13",
    line4: "STREET NO. 372, AA II, NEWTOWN",
    line5: "CHAKPACHURIA, WEST BENGAL 700160, INDIA"
  }
};

export const navLinks = [
  { name: "HOME", path: "/" },
  { name: "ABOUT US", path: "/about" },
  { name: "SERVICES", path: "/services" },
  { name: "APPROACH", path: "/approach" },
  { name: "INSIGHTS", path: "/insights" },
  { name: "LIBRARY", path: "/library" },
  { name: "MEMBERS", path: "/member-login" },
  { name: "CONTACT", path: "/contact" }
];

export const hero = {
  title: ["BEHIND EVERY", "ARTIFACT, A TRUTH"],
  subtitle: "Where History Meets Rarity Artifacts & More......",
  image: "https://images.unsplash.com/photo-1606206873764-fd15e242df52?w=1200&q=80"
};

export const services = [
  {
    id: "research",
    title: "Research",
    image: "https://images.unsplash.com/photo-1614935151651-0bea6508db6b?w=400&q=80",
    description: "Creative and systematic work to expand human knowledge. We analyze and organize data to gain insights and uncover truth with minimal bias and maximum clarity.",
    long: "Our research division applies rigorous methodology, statistical modeling, and creative insight to solve complex business questions. From market analysis to scientific discovery, we deliver actionable intelligence."
  },
  {
    id: "finance",
    title: "Finance",
    image: "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=400&q=80",
    description: "Strategic planning, investing, and managing money in personal, corporate, and public sectors. Empowering businesses with financial intelligence and tools.",
    long: "With deep roots in finance, we deliver strategic insights across personal, corporate, and public sectors. From traditional investments to fintech innovation, we help clients make data-driven, growth-oriented decisions."
  },
  {
    id: "auction",
    title: "Auction",
    image: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?w=400&q=80",
    description: "Secure and professional bidding platforms for rare assets, antiques, and bullion. Global exposure, expert curation, and verified provenance.",
    long: "From heritage auctions to high-tech bidding, we bridge tradition and innovation. Our digital auction platforms ensure transparency, accessibility, and real-time competition across industries."
  }
];

export const mvv = [
  {
    key: "MISSION",
    color: "bg-rose-500",
    icon: "Rocket",
    body: "To empower businesses with intelligent, scalable, and future-ready software solutions. We combine deep industry insights with hands-on technical expertise to help our clients optimize workflows, reduce costs, and unlock new growth opportunities...."
  },
  {
    key: "VISION",
    color: "bg-blue-600",
    icon: "Eye",
    body: "To be a recognized leader in digital transformation \u2014 enabling enterprises worldwide to thrive in an ever-evolving technological landscape. We envision a future where companies leverage our tailored digital systems to adapt seamlessly and stay ahead...."
  },
  {
    key: "VALUES",
    color: "bg-amber-400",
    iconColor: "text-white",
    icon: "Gem",
    body: "Close teamwork with clients, not just as vendors. We partner to build real results together. Proactive adoption of emerging technologies to keep clients ahead of the curve. Transparent, accountable, and ethical in every engagement and decision we make..."
  }
];

export const aboutSections = [
  {
    title: "Pioneering Knowledge & Innovation",
    body: "At ASTORIA SOLUTIONS, research is a journey of discovery. Grounded in rigorous methodology and creative insight, we expand the boundaries of human knowledge with integrity, transparency, and precision."
  },
  {
    title: "Financial Expertise that Builds Futures",
    body: "With deep roots in finance, we deliver strategic insights across personal, corporate, and public sectors. From traditional investments to fintech innovation, we help clients make data-driven, growth-oriented decisions."
  },
  {
    title: "Reimagining Auctions for the Digital Age",
    body: "From heritage auctions to high-tech bidding, we bridge tradition and innovation. Our digital auction platforms ensure transparency, accessibility, and real-time competition across industries."
  },
  {
    title: "A Legacy of Integrity and Progress",
    body: "With a vision rooted in ethics and progress, ASTORIA SOLUTIONS blends innovation, trust, and professionalism. We champion a future where every solution is impactful, inclusive, and intelligent."
  }
];

export const approachSteps = [
  {
    step: "01",
    title: "Discovery",
    description: "We begin by deeply understanding your business, goals, and challenges. Through workshops and stakeholder interviews we align on what success looks like."
  },
  {
    step: "02",
    title: "Strategy",
    description: "Our team crafts a tailored roadmap combining research, financial modeling, and market intelligence \u2014 turning insights into decisive action."
  },
  {
    step: "03",
    title: "Execution",
    description: "Agile delivery, weekly checkpoints, and full transparency ensure the plan becomes reality \u2014 on time and within budget."
  },
  {
    step: "04",
    title: "Growth",
    description: "We stay engaged post-launch, measuring outcomes, iterating on data, and helping your organization compound results year over year."
  }
];

export const heroBanner = {
  tagline: "Empowering Enterprises with Precision & Trust",
  title: ["Excellence in Insight,", "Confidence in Every Outcome"],
  subtitle: "Your dependable partner in Research, Finance and Auction advisory \u2014 delivering measurable impact worldwide.",
  bgImage: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1800&q=80"
};

export const pillars = [
  {
    icon: "Leaf",
    title: "Sustainability",
    body: "We help clients pursue a more responsible, future-ready path. Environmental stewardship guides every engagement and reduces long-term project risk."
  },
  {
    icon: "ShieldCheck",
    title: "Integrity",
    body: "We operate with honesty and accountability, respecting the regulations, standards and cultural norms of every market in which we work."
  },
  {
    icon: "Award",
    title: "Quality Service",
    body: "Clients trust our objective third-party analysis, testing and advisory to ensure their products, processes and outcomes meet modern benchmarks."
  }
];

export const aboutHome = {
  years: "15+",
  yearsLabel: "Years of Combined Expertise",
  heading: "A knowledge-led firm helping ambitious teams achieve their boldest goals.",
  body1: "ASTORIA SOLUTIONS transforms discoveries and insights into practical products, financial strategies and auction platforms that create lasting value for people, businesses and the planet.",
  body2: "By reducing cost, elevating quality and honouring each client's own capability, we consistently deliver outcomes grounded in shared expertise and collaborative discipline.",
  images: [
    "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80",
    "https://images.unsplash.com/photo-1526930382372-67bf22c0fce2?w=600&q=80",
    "https://images.unsplash.com/photo-1614935151651-0bea6508db6b?w=600&q=80"
  ]
};

export const valuePoints = [
  {
    icon: "Rocket",
    title: "Mission",
    body: "To help enterprises make sharper decisions that lower risk and unlock growth. We build tools and frameworks that turn information into confident action."
  },
  {
    icon: "Eye",
    title: "Vision",
    body: "To deliver superior innovation, insight and discovery through our people, partners and depth of domain knowledge across research, finance and auction."
  },
  {
    icon: "Zap",
    title: "Efficiency",
    body: "Our flexible engagement models let clients adopt new processes quickly. We streamline, accelerate and elevate every workflow we touch."
  },
  {
    icon: "Gem",
    title: "Values",
    body: "Our capabilities and strategy are anchored to values. We hold ourselves to high standards, and to warm, honest collaboration with every stakeholder."
  },
  {
    icon: "Timer",
    title: "Speed to Market",
    body: "Accelerated market entry requires fit with local expectations. Our advisory helps clients understand the terrain and move with clarity and pace."
  }
];

export const gallery = [
  "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
  "https://images.unsplash.com/photo-1614935151651-0bea6508db6b?w=800&q=80",
  "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80",
  "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?w=800&q=80",
  "https://images.unsplash.com/photo-1526930382372-67bf22c0fce2?w=800&q=80",
  "https://images.unsplash.com/photo-1606206873764-fd15e242df52?w=800&q=80"
];

export const caseStudies = {
  research: [
    {
      slug: "novacore-labs-trial",
      client: "NovaCore Labs",
      title: "Reduced trial cycle by 38% via data-driven protocol design",
      metric: "38%",
      metricLabel: "Faster trials",
      quote: "Astoria\u2019s research team rebuilt our discovery pipeline. What used to take a year now finishes in under seven months.",
      author: "VP Discovery, NovaCore Labs",
      image: "https://images.unsplash.com/photo-1614935151651-0bea6508db6b?w=1200&q=80",
      industry: "Life Sciences",
      duration: "9 months",
      services: ["Data Analysis", "Protocol Redesign", "Regulatory Advisory"],
      challenge: "NovaCore\u2019s discovery pipeline was slowed by fragmented data systems, redundant protocols, and manual quality checks. Time from hypothesis to first-cohort readout averaged 51 weeks.",
      approach: "Astoria embedded a hybrid team of data scientists and clinical advisors. We consolidated protocol libraries, introduced adaptive trial design, and built a live decision dashboard that surfaced blockers in near-real-time.",
      outcome: "Cycle time compressed by 38%, quality flags dropped 60%, and the leadership team now steers R&D with weekly metric reviews instead of quarterly reports.",
      results: [
        { value: "38%", label: "Faster trial cycles" },
        { value: "60%", label: "Fewer quality flags" },
        { value: "3\u00d7", label: "Faster reporting" }
      ],
      timeline: [
        { phase: "Weeks 1-4", title: "Discovery", body: "Interviews across R&D, ops and QA to map the true bottleneck landscape." },
        { phase: "Weeks 5-10", title: "Protocol Redesign", body: "Consolidated fragmented protocols and introduced adaptive design guardrails." },
        { phase: "Weeks 11-24", title: "Pilot", body: "Two live studies executed on the new operating model with dashboard oversight." },
        { phase: "Weeks 25-36", title: "Scale", body: "Rolled out organization-wide with training and a live decision cockpit." }
      ],
      gallery: [
        "https://images.unsplash.com/photo-1526930382372-67bf22c0fce2?w=800&q=80",
        "https://images.unsplash.com/photo-1614935151651-0bea6508db6b?w=800&q=80",
        "https://images.unsplash.com/photo-1606206873764-fd15e242df52?w=800&q=80"
      ]
    },
    {
      slug: "helios-alloys",
      premium: true,
      client: "Helios Materials",
      title: "Identified 4 new alloy candidates in 90 days",
      metric: "4\u00d7",
      metricLabel: "Faster discovery",
      quote: "The rigour and creativity of the Astoria analysts is unmatched. They found opportunities we\u2019d missed for years.",
      author: "CTO, Helios Materials",
      image: "https://images.unsplash.com/photo-1526930382372-67bf22c0fce2?w=1200&q=80",
      industry: "Advanced Materials",
      duration: "3 months",
      services: ["Materials Analysis", "Simulation", "Vendor Qualification"],
      challenge: "Helios needed lower-cost alloys that met aerospace-grade tolerances. The internal team had explored the same shortlist for three years without a breakthrough.",
      approach: "We combined literature mining, simulation and vendor sampling to widen the search space. A weighted scoring rubric prioritised candidates by cost, availability, and mechanical performance.",
      outcome: "Four candidates cleared bench tests; two entered field trials within the quarter.",
      results: [
        { value: "4", label: "Candidates identified" },
        { value: "27%", label: "Projected cost saving" },
        { value: "2", label: "In field trials" }
      ],
      timeline: [
        { phase: "Weeks 1-2", title: "Search Space", body: "Broadened the exploration domain with literature mining and simulation." },
        { phase: "Weeks 3-6", title: "Sampling", body: "Vendor sampling and controlled bench testing across shortlisted alloys." },
        { phase: "Weeks 7-12", title: "Shortlist", body: "Ranked outputs and produced a decision brief for the executive team." }
      ],
      gallery: [
        "https://images.unsplash.com/photo-1606206873764-fd15e242df52?w=800&q=80",
        "https://images.unsplash.com/photo-1526930382372-67bf22c0fce2?w=800&q=80"
      ]
    }
  ],
  finance: [
    {
      slug: "sable-wealth",
      client: "Sable Wealth Partners",
      title: "Restructured portfolio delivered 22% IRR uplift",
      metric: "+22%",
      metricLabel: "IRR uplift",
      quote: "Astoria brought clarity to a very complex balance sheet. Their models are now core to how we invest.",
      author: "Managing Director, Sable Wealth Partners",
      image: "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=1200&q=80",
      industry: "Asset Management",
      duration: "6 months",
      services: ["Portfolio Analysis", "Risk Modelling", "Rebalancing"],
      challenge: "Sable\u2019s flagship fund carried concentration risk and stale hedges. Recent volatility exposed exposures that historical VaR had missed.",
      approach: "We rebuilt the risk model with regime-aware assumptions, ran scenario analyses across three market states, and produced an actionable rebalancing plan.",
      outcome: "The rebalanced portfolio outperformed the benchmark by 220 bps over the following two quarters with materially lower drawdown.",
      results: [
        { value: "+22%", label: "IRR uplift" },
        { value: "-31%", label: "Drawdown risk" },
        { value: "220bps", label: "Benchmark alpha" }
      ],
      timeline: [
        { phase: "Weeks 1-3", title: "Audit", body: "Full audit of positions, hedges and historic returns." },
        { phase: "Weeks 4-10", title: "Modelling", body: "Regime-aware risk model with scenario analyses across 3 market states." },
        { phase: "Weeks 11-24", title: "Rebalance", body: "Executed rebalance with weekly steering meetings and outcome tracking." }
      ],
      gallery: [
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
        "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80"
      ]
    },
    {
      slug: "bramble-fintech",
      client: "Bramble Fintech",
      title: "Launched compliant micro-lending across 3 markets",
      metric: "3",
      metricLabel: "New markets",
      quote: "Regulatory alignment and go-to-market clarity \u2014 all delivered in one crisp engagement.",
      author: "Co-Founder, Bramble Fintech",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80",
      industry: "Fintech",
      duration: "5 months",
      services: ["Regulatory Advisory", "GTM Strategy", "Ops Design"],
      challenge: "Bramble had product-market fit locally but was blocked from scaling due to inconsistent regulatory readiness and unclear ops requirements per market.",
      approach: "We mapped compliance and operating models across three target markets in parallel, then sequenced launch based on effort, revenue and risk.",
      outcome: "Compliant launches in three new markets with an ops playbook that has since supported two additional country rollouts.",
      results: [
        { value: "3", label: "New markets" },
        { value: "8 weeks", label: "Average launch time" },
        { value: "0", label: "Regulatory findings" }
      ],
      timeline: [
        { phase: "Month 1", title: "Regulatory Map", body: "Detailed compliance map across three target markets." },
        { phase: "Month 2", title: "Ops Blueprint", body: "Designed unified ops model with market-specific overlays." },
        { phase: "Months 3-5", title: "Launch", body: "Sequential launch with weekly readiness reviews and issue log." }
      ],
      gallery: [
        "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=800&q=80",
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
      ]
    }
  ],
  auction: [
    {
      slug: "meridian-fine-arts",
      client: "Meridian Fine Arts",
      title: "Doubled online bidder participation in one season",
      metric: "2\u00d7",
      metricLabel: "Bidder growth",
      quote: "The digital auction platform Astoria built is now the benchmark our peers try to match.",
      author: "Head of Sales, Meridian Fine Arts",
      image: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?w=1200&q=80",
      industry: "Fine Art & Antiques",
      duration: "8 months",
      services: ["Digital Platform", "UX Design", "Bidder Trust"],
      challenge: "Meridian\u2019s digital experience was clunky and lacked trust signals. Their strongest bidders still preferred phone-in bidding.",
      approach: "We rebuilt the bidding experience with clear provenance signals, live streaming and identity-verified bidder tiers.",
      outcome: "Online participation doubled and average lot price climbed 18% over one full season.",
      results: [
        { value: "2\u00d7", label: "Bidder growth" },
        { value: "+18%", label: "Average lot price" },
        { value: "94%", label: "Trust score" }
      ],
      timeline: [
        { phase: "Month 1-2", title: "Trust Audit", body: "Deep-dive interviews with top bidders to map trust friction." },
        { phase: "Month 3-6", title: "Rebuild", body: "New bidder tiers, provenance signals and live-stream studio." },
        { phase: "Month 7-8", title: "Launch", body: "Season launch with concierge support for high-value bidders." }
      ],
      gallery: [
        "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?w=800&q=80",
        "https://images.unsplash.com/photo-1606206873764-fd15e242df52?w=800&q=80"
      ]
    },
    {
      slug: "aurabullion",
      premium: true,
      client: "AuraBullion",
      title: "Verified provenance for 12,000+ rare assets",
      metric: "12K+",
      metricLabel: "Assets verified",
      quote: "Trust is the whole product in our industry. Astoria helped us earn more of it, faster.",
      author: "CEO, AuraBullion",
      image: "https://images.unsplash.com/photo-1606206873764-fd15e242df52?w=1200&q=80",
      industry: "Precious Assets",
      duration: "10 months",
      services: ["Provenance", "Verification Ops", "Buyer Assurance"],
      challenge: "AuraBullion was scaling faster than its verification pipeline. Backlogs eroded trust and slowed sell-through.",
      approach: "We redesigned the verification workflow with tiered SLAs, expert reviewers per asset class, and a customer-facing provenance record.",
      outcome: "Backlog eliminated within four months and 12,000+ assets fully verified with a public provenance record.",
      results: [
        { value: "12K+", label: "Assets verified" },
        { value: "0", label: "Backlog days" },
        { value: "+41%", label: "Sell-through" }
      ],
      timeline: [
        { phase: "Month 1", title: "Audit", body: "Mapped bottlenecks in the verification pipeline." },
        { phase: "Month 2-4", title: "Redesign", body: "Introduced SLA tiers and expert routing." },
        { phase: "Month 5-10", title: "Rollout", body: "Full rollout, backlog cleared, provenance record launched." }
      ],
      gallery: [
        "https://images.unsplash.com/photo-1606206873764-fd15e242df52?w=800&q=80",
        "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?w=800&q=80"
      ]
    }
  ]
};

export const team = [
  {
    slug: "founder-ceo",
    role: "Founder & CEO",
    department: "Leadership",
    bio: "Two decades leading multi-disciplinary teams across research and financial advisory.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=800&q=80",
    linkedin: "#",
    email: "ceo@astoriasolutions.com",
    location: "Mumbai, India",
    expertise: ["Corporate Strategy", "Cross-border Advisory", "Governance"],
    long: "The Founder & CEO built Astoria on a simple belief: that great firms are built where research rigor meets human judgment. Two decades across consulting and asset management shape how the firm chooses engagements and grows talent.",
    engagements: [
      { title: "Chaired a cross-border M&A advisory for a mid-market fintech", year: "2024" },
      { title: "Advised a family office on multi-generational succession", year: "2023" },
      { title: "Board seat, National Innovation Council working group", year: "2022" }
    ]
  },
  {
    slug: "chief-operating-officer",
    role: "Chief Operating Officer",
    department: "Operations",
    bio: "Scales operations with a bias for outcomes, discipline, and warm collaboration.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80",
    linkedin: "#",
    email: "coo@astoriasolutions.com",
    location: "Bengaluru, India",
    expertise: ["Operations", "Engagement Delivery", "Talent Ops"],
    long: "The COO brings a rare mix of empathy and precision to how Astoria runs \u2014 designing the delivery model, mentoring project leads and ensuring every engagement lands on time, on budget and with a very human touch.",
    engagements: [
      { title: "Set up a delivery hub serving three geographies", year: "2024" },
      { title: "Introduced OKR-based engagement tracking firm-wide", year: "2023" }
    ]
  },
  {
    slug: "head-of-research",
    role: "Head of Research",
    department: "Research",
    bio: "PhD in applied statistics; published across market analytics and materials science.",
    image: "https://images.unsplash.com/photo-1627161683077-e34782c24d81?w=800&q=80",
    linkedin: "#",
    email: "research@astoriasolutions.com",
    location: "Pune, India",
    expertise: ["Applied Statistics", "Causal Inference", "R&D Strategy"],
    long: "The Head of Research leads the studio at Astoria. The team believes the best research is decision-grade \u2014 built to answer a question, not merely publish a chart. Work has shipped across life sciences, energy and advanced materials.",
    engagements: [
      { title: "Led alloy discovery program that cleared bench for 4 candidates", year: "2024" },
      { title: "Built causal inference framework for a healthcare payer", year: "2023" }
    ]
  },
  {
    slug: "head-of-finance-advisory",
    role: "Head of Finance Advisory",
    department: "Finance",
    bio: "Former investment banker helping mid-market firms think institutionally about growth.",
    image: "https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?w=800&q=80",
    linkedin: "#",
    email: "finance@astoriasolutions.com",
    location: "Mumbai, India",
    expertise: ["Corporate Finance", "Private Credit", "Deal Structuring"],
    long: "Finance Advisory helps mid-market companies think and operate like institutions. Over a billion dollars of debt and equity has been structured across sectors, now supporting founders and CFOs stepping into their next inflection point.",
    engagements: [
      { title: "Structured a $180M growth round for a consumer platform", year: "2024" },
      { title: "Ran a portfolio rebalance yielding 220 bps of alpha", year: "2023" }
    ]
  },
  {
    slug: "head-of-auctions",
    role: "Head of Auctions",
    department: "Auction",
    bio: "Curated over 400 auctions across fine art, antiques, and rare bullion assets.",
    image: "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg?auto=compress&cs=tinysrgb&h=800&w=1200",
    linkedin: "#",
    email: "auctions@astoriasolutions.com",
    location: "Delhi, India",
    expertise: ["Provenance", "Auction Design", "Buyer Trust"],
    long: "The Auction practice has spent a career building trust into the most opaque parts of the industry. It now leads Astoria\u2019s auction work, blending old-world curation with modern platform design.",
    engagements: [
      { title: "Curated the debut season of a live-streamed heritage auction", year: "2024" },
      { title: "Verified provenance for 12,000+ rare assets", year: "2023" }
    ]
  }
];

export const specializedServices = [
  {
    id: "land-remediation",
    title: "Land Remediation",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&q=80",
    icon: "Sprout",
    body: "Advisory and program management for cleaning contaminated soil, sediment and water. We help clients scope the work, select the right technologies, engage regulators early, and evidence measurable environmental recovery."
  },
  {
    id: "radiation-safety",
    title: "Radiation Safety & Protection",
    image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800&q=80",
    icon: "ShieldAlert",
    body: "Compliance, training and monitoring programs that keep people, sites and workflows safe from ionizing-radiation risk. From dosimetry design to occupational exposure reviews and shielding validation."
  },
  {
    id: "environmental-protection",
    title: "Environmental Protection",
    image: "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=800&q=80",
    icon: "Leaf",
    body: "End-to-end environmental advisory covering baseline studies, impact assessment, regulatory filings and long-term monitoring \u2014 so operations stay clean, compliant and reputationally strong."
  },
  {
    id: "borescope-inspection",
    title: "Borescope Inspection",
    image: "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=800&q=80",
    icon: "Search",
    body: "Non-destructive visual inspection for the places human eyes cannot reach \u2014 turbines, pipelines, enclosed vessels and rotating machinery. Findings become clear, priority-ranked maintenance plans."
  },
  {
    id: "testing-analysis",
    title: "Testing & Analysis",
    image: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=800&q=80",
    icon: "TestTube",
    body: "Certified laboratory testing for fuels, oils, hydraulic fluids and materials. We interpret the numbers, benchmark them against relevant standards, and translate the science into engineering decisions."
  },
  {
    id: "litigation-support",
    title: "Litigation Support",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
    icon: "Scale",
    body: "Independent expert analysis for pre-litigation, active disputes and settlement negotiations. We focus on economic-loss quantification and technically defensible evidence that stands up to scrutiny."
  },
  {
    id: "operations",
    title: "Operations",
    image: "https://images.unsplash.com/photo-1581093458791-9d09c8f9c0b8?w=800&q=80",
    icon: "Settings",
    body: "Experienced operators supporting the day-to-day running and maintenance of radiation and heavy-industrial facilities \u2014 with a bias for uptime, safety and calm execution under pressure."
  },
  {
    id: "decommissioning",
    title: "Decommissioning",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80",
    icon: "PackageX",
    body: "Structured, safety-first decommissioning of contaminated assets \u2014 from initial hazard mapping and de-risking through dismantling, waste routing and final site clearance sign-off."
  },
  {
    id: "waste-management",
    title: "Waste Management",
    image: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=800&q=80",
    icon: "Recycle",
    body: "We bring both the know-how and the in-house designs required to handle solid, liquid and specialty waste streams \u2014 aligning treatment choices with cost, compliance and environmental outcomes."
  }
];

export const insights = [
  {
    slug: "data-driven-2026",
    category: "Research",
    premium: false,
    title: "The 2026 shift: turning noisy data into confident decisions",
    excerpt: "How modern research teams are moving from dashboards to decision-grade intelligence.",
    author: "Head of Research",
    authorSlug: "head-of-research",
    date: "Feb 12, 2026",
    readTime: "6 min",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1400&q=80",
    tags: ["Research", "Analytics", "Decision Science"],
    content: [
      { type: "p", text: "For a decade, the dominant playbook in analytics has been to build more dashboards. In 2026 that playbook is quietly ending. Executives no longer want views \u2014 they want decisions." },
      { type: "h", text: "From dashboards to decision cockpits" },
      { type: "p", text: "The shift is subtle but structural. The best research teams are pruning dashboards, standing up short-lived decision cockpits, and pairing them with clear owners and thresholds." },
      { type: "quote", text: "A dashboard reports the past. A cockpit forces a choice." },
      { type: "h", text: "Three moves that separate the leaders" },
      { type: "list", items: [
        "They keep fewer metrics and defend them fiercely.",
        "They pair every metric with an owner, a threshold and an action.",
        "They ruthlessly kill dashboards that no one reads."
      ] },
      { type: "p", text: "None of this is technology. It\u2019s discipline. The tools have been ready for years." }
    ]
  },
  {
    slug: "private-credit-outlook",
    category: "Finance",
    premium: true,
    title: "Private credit outlook: what mid-market CFOs should prepare for",
    excerpt: "Rates, covenants and structuring: our field notes from the last two quarters.",
    author: "Head of Finance Advisory",
    authorSlug: "head-of-finance-advisory",
    date: "Jan 28, 2026",
    readTime: "8 min",
    image: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=1400&q=80",
    tags: ["Finance", "Private Credit", "CFO"],
    content: [
      { type: "p", text: "Private credit continues to widen its share of the mid-market funding stack, but the terms are moving. Here\u2019s what we\u2019re seeing across recent engagements." },
      { type: "h", text: "Where terms are tightening" },
      { type: "list", items: [
        "Maintenance covenants are back on more than half of deals we tracked.",
        "Sponsors are trading a lower coupon for looser call protection.",
        "Warrants and equity kickers appear in roughly one in four term sheets."
      ] },
      { type: "h", text: "What CFOs should do this quarter" },
      { type: "p", text: "Run a covenant stress test at plus 200 bps and plus 400 bps. Pressure-test your headroom against a slower revenue path. And keep a live map of two alternative lenders per tranche \u2014 it dramatically improves your negotiating position when refinancing time comes." }
    ]
  },
  {
    slug: "digital-auction-playbook",
    category: "Auction",
    premium: true,
    title: "The digital auction playbook: trust, transparency and scale",
    excerpt: "Five principles that separate high-performing bidding platforms from the rest.",
    author: "Head of Auctions",
    authorSlug: "head-of-auctions",
    date: "Jan 06, 2026",
    readTime: "5 min",
    image: "https://images.unsplash.com/photo-1644088379091-d574269d422f?w=1400&q=80",
    tags: ["Auction", "Trust", "Product"],
    content: [
      { type: "p", text: "Every auction platform will tell you it takes trust seriously. Few actually build for it. Here are the principles we return to in every engagement." },
      { type: "h", text: "The five principles" },
      { type: "list", items: [
        "Provenance is a first-class product surface, not a footnote.",
        "Identity-verified bidder tiers unlock higher-value lots.",
        "Live-streaming reduces buyer regret dramatically.",
        "Trust scores must be earned by sellers, not bought.",
        "Every dispute must have a visible resolution path."
      ] },
      { type: "p", text: "The platforms that master these move from being a marketplace to being an institution." }
    ]
  }
];
